import axios from "axios";
import { HttpLink } from "@apollo/client";
import { chooseapihost } from "./api";

export class OpenAIApi {
  constructor() {
    this.httpLink = null;
    this.axiosClient = null;
    this.defaultConfig = { model: "gpt-4.1" };
  }

  async initialize() {
    const [host, isSecure] = await chooseapihost();

    this.httpLink = new HttpLink({
      uri: `http${isSecure ? "s" : ""}://${host}/openai`,
      credentials: "include",
    });

    this.axiosClient = axios.create({
      baseURL: this.httpLink.options.uri,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  async createChatCompletion(configData) {
    if (!this.httpLink || !this.axiosClient) {
      await this.initialize();
    }

    try {
      const auSystemMessage = {
        role: "system",
        content: "You are a helpful assistant. Use Australian English spelling, grammar, and tone in all responses.",
      };

      const originalMessages = configData.messages || [];

      const updatedConfig = {
        ...this.defaultConfig,
        ...configData,
        messages: [auSystemMessage, ...originalMessages],
      };

      const resp = await this.axiosClient.post("/chat/completions", updatedConfig);

      console.info("OpenAIApi.createChatCompletion", resp);
      return resp;
    } catch (error) {
      console.error(error?.message);
      return {
        status: 400,
        data: {
          choices: [],
        },
      };
    }
  }
}
